"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMultiLocaleValues = exports.browserLocale = exports.searchParamLocale = exports.getNeraestLocale = exports.availableLocaleOptions = exports.availableLocales = exports.languageMapper = exports.messages = void 0;
const languages_1 = require("utils/languages");
exports.messages = {
    en: languages_1.en,
    ja: languages_1.ja,
    zh: languages_1.zhTw,
    // "zh-tw": zhTw,
};
exports.languageMapper = {
    ja: "日本語",
    en: "英語",
    zh: "中国語",
};
exports.availableLocales = Object.keys(exports.messages)
    .map((locale) => {
    return [locale === "ja" ? "" : locale, locale];
})
    .sort((a, b) => {
    return a[0].localeCompare(b[0]);
})
    .map((a) => a[1]);
exports.availableLocaleOptions = exports.availableLocales.map((locale) => {
    var _a;
    return {
        value: locale,
        title: (_a = exports.messages[locale]) === null || _a === void 0 ? void 0 : _a.Language,
    };
});
const getNeraestLocale = (locale) => {
    if (!locale) {
        return undefined;
    }
    if (locale in exports.messages) {
        return locale;
    }
    const lang = locale.split(/[-_]/)[0];
    if (lang in exports.messages) {
        return lang;
    }
};
exports.getNeraestLocale = getNeraestLocale;
exports.searchParamLocale = (0, exports.getNeraestLocale)(new URLSearchParams(window.location.search).get("locale") || undefined);
exports.browserLocale = (0, exports.getNeraestLocale)(navigator.language) || "ja";
const getMultiLocaleValues = (multiLocalteValues) => {
    const { ja } = multiLocalteValues, multiLocaleValuesExceptJa = __rest(multiLocalteValues, ["ja"]);
    return Object.values(multiLocaleValuesExceptJa).every((v) => !v)
        ? ja
        : multiLocalteValues;
};
exports.getMultiLocaleValues = getMultiLocaleValues;
